import { MANAGE_ROLES, ManageMeI } from "@/api/routes/manage";

/**
 * Pure readers of `manage/me` (C-14). Kept free of the API client so the
 * redirect and nav helpers can use them without pulling in Auth0.
 */

/** True when the user holds at least one grant. */
export const hasManageRoles = (me: ManageMeI | null | undefined): boolean =>
  !!me && (me.is_admin || me.roles.length > 0);

export const isManageLga = (me: ManageMeI | null | undefined): boolean =>
  !!me && me.roles.some((role) => role.role === MANAGE_ROLES.LGA);

export const isManagePodLead = (me: ManageMeI | null | undefined): boolean =>
  !!me && me.roles.some((role) => role.role === MANAGE_ROLES.POD_LEAD);
